// Suppress i18n "Not found parent scope" warnings in SSG/static mode
// This warning is a false positive during dev/hydration for static sites
// The warning occurs because vue-i18n checks for parent scope during SSR,
// but in SSG mode, this check is unnecessary since all pages are prerendered
export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    // Store original warn function
    const originalWarn = console.warn
    
    // Override console.warn to filter out the specific i18n warning
    console.warn = (...args: unknown[]) => {
      // Check if this is the "Not found parent scope" warning from vue-i18n
      const firstArg = args[0]
      if (
        typeof firstArg === 'string' &&
        (firstArg.includes('Not found parent scope') ||
         firstArg.includes('[intlify] Not found parent scope'))
      ) {
        // Suppress this specific warning for SSG/static mode
        return
      }
      
      // Pass through all other warnings
      originalWarn.apply(console, args)
    }
  }
})
